import { combineReducers } from '@reduxjs/toolkit'

import { NameSpace } from '@/store/nameSpace'

import appReducer from './app'

export const rootReducer = combineReducers({
  [NameSpace.APP]: appReducer,
})
